import React, { Component, useState } from "react";
import styled from "styled-components";
import ReactPaginate from "react-paginate";


import { MsgExecuteContract, SyncTxBroadcastResult } from '@terra-money/terra.js';
import {
    createLCDClient,
    CreateTxFailed,
    SignResult,
    Timeout,
    TxFailed,
    TxUnspecifiedError,
    useConnectedWallet,
    UserDenied,
} from '@terra-money/wallet-provider';

const CONTRACT_ADDRESS = 'terra19sndpzw0skhlrhh5wlmq43dj9nqfggwylh0w2t';

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

const ColumnZero = function () {

    const [dummyData, setData] = React.useState([]);
    const [endLoading, setEndLoading] = React.useState(false);
    let data = []
    const connectedWallet = useConnectedWallet();

    if (!endLoading) {
        if (!connectedWallet) {
            return (
                <div>Connect Wallet</div>
            );
        }

        // if (connectedWallet.network.chainID.startsWith('columbus')) {
        //     alert(`Please only execute this example on Testnet`);
        //     return (
        //         <div>Connect Wallet</div>
        //     );
        // }

        const terra = new createLCDClient({ network: connectedWallet.network });
        const queryMsg = {
            "tokens": {
                "owner": connectedWallet.terraAddress.toString(),
            }
        }

        terra.wasm.contractQuery(CONTRACT_ADDRESS, queryMsg).then((result) => {
            for (const token of result.tokens) {
                data.push({
                    previewImg: `https://merryterrachristmas.s3.ap-northeast-2.amazonaws.com/santa_seals/${token}.gif`,
                    title: "#1",
                });
            }
            setEndLoading(true);
            setData(data);

            // if (!token.owner.localeCompare(CONTRACT_ADDRESS)) {
            //     data.push({
            //         previewImg: `https://merryterrachristmas.s3.ap-northeast-2.amazonaws.com/santaseals/${token_id}.gif`,
            //         title: "#1",
            //         owner: "NO owner yet!!!"
            //     });
            // }

            // if (data.length == all_tokens.length) {
            //     setEndLoading(true);
            //     setData(data);
            // }
        })
    }
    return (
        <div className='row'>
            {dummyData.map((nft, index) => (
                <div key={index} className="d-item col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="nft__item">
                        <div className="nft__item_wrap">
                            <Outer>
                                <span>
                                    <img src={nft.previewImg} className="lazy nft__item_preview" alt="" />
                                </span>
                            </Outer>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ColumnZero;